import { useState } from 'react'
import { Button, Input, Space, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

interface ContactRevealControlProps {
  onReveal: (reason: string) => void
  revealing?: boolean
  revealError?: string | null
}

/**
 * «To'liq raqamni ochish» boshqaruvi — sabab + tugma.
 *
 * ⚠️ ATAYLAB ALOHIDA KOMPONENT. Ochish ikki joyda taklif qilinadi:
 * tahrirlash formasida (u yerda saqlash uchun kerak) va kartochkadagi
 * faqat o'qish uchun kontakt blokida. Ikkala nusxada sabab maydoni
 * ayri yozilsa, biri «sababsiz ham bo'ladi» holatiga sirg'anib ketardi
 * va audit jurnali bo'sh sabablar bilan to'lardi.
 *
 * ⚠️ Sabab BO'SH bo'lsa tugma o'chiq — server ham rad etadi, lekin
 * so'rov umuman ketmasligi kerak: har urinish auditga tushadi.
 *
 * ⚠️ Bu komponent o'zi HECH NARSA chaqirmaydi. Ochish faqat bosish
 * bilan boshlanadi: sahifa ochilishida avtomatik chaqirilsa, jurnal
 * «kim to'liq raqamni ko'rdi» degan savolga javob berolmay qolardi.
 */
export function ContactRevealControl({
  onReveal,
  revealing = false,
  revealError = null,
}: ContactRevealControlProps) {
  const { t } = useTranslation()
  const [reason, setReason] = useState('')

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={8}>
      <Space.Compact style={{ width: '100%' }}>
        <Input
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          placeholder={t('contact.revealReason')}
          maxLength={200}
        />
        <Button
          type="primary"
          loading={revealing}
          disabled={reason.trim() === ''}
          onClick={() => onReveal(reason.trim())}
        >
          {t('contact.reveal')}
        </Button>
      </Space.Compact>
      <Typography.Text type="secondary">{t('contact.revealWarn')}</Typography.Text>
      {revealError ? <Typography.Text type="danger">{revealError}</Typography.Text> : null}
    </Space>
  )
}
